import type {
  ContactSubmissionInput,
  ContactSubmissionRecord,
  ContactSubmissionStatus,
  WarrantyClaimInput,
  WarrantyClaimRecord,
} from '@/lib/domain';
import { apiGet, apiSend } from '@/lib/api/client';

export async function submitContactForm(input: ContactSubmissionInput) {
  return apiSend<null>('/forms/contact.php', 'POST', input);
}

export async function submitWarrantyClaim(input: WarrantyClaimInput) {
  return apiSend<null>('/forms/warranty.php', 'POST', input);
}

export async function fetchWarrantyClaims(): Promise<WarrantyClaimRecord[]> {
  return apiGet<WarrantyClaimRecord[]>('/admin/warranty-claims.php');
}

export async function fetchContactSubmissions(): Promise<ContactSubmissionRecord[]> {
  return apiGet<ContactSubmissionRecord[]>('/admin/contact-submissions.php');
}

export async function updateContactSubmission(
  submissionId: string,
  input: {
    status?: ContactSubmissionStatus;
    adminNotes?: string;
  },
) {
  return apiSend<ContactSubmissionRecord>('/admin/contact-submissions.php', 'PATCH', {
    submissionId,
    ...input,
  });
}

export async function updateWarrantyClaimStatus(
  claimId: string,
  status: WarrantyClaimRecord['status'],
) {
  return apiSend<null>('/admin/warranty-claims.php', 'PATCH', { claimId, status });
}
